// extracted by mini-css-extract-plugin
export default {"root":"CategoriesForm_root__tqxN0","radios":"CategoriesForm_radios__488cz"};